import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { initHolid } from './holid-ad-helper';
import { useSelector } from 'react-redux';

const HolidAd = ({ id, adClass }) => {
    const environment = useSelector(state => state.environment);
    const isTest = environment.environment === 'test';

    useEffect(() => {
        initHolid(isTest);
    }, [isTest]);

    return <div id={`holid-ad-${id}`} className={`holidAds ${adClass}`} />;
};

HolidAd.propTypes = {
    id: PropTypes.string,
    adClass: PropTypes.string
};

export default HolidAd;
